<script>

import { useToast } from "vue-toastification";

import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getTask, deleteTask } from '@/services/working/serviceTask';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'TaskDelete',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'taskId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["taskId","changeRecord"],
	data() {
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			//form
			data:[]
		}
	},
	
	mounted:function(){
	
	},
	
	methods: {
	
		// load data form
		loadDefaultValues:function(){
			
			this.isLoading=true

			getTask({taskId:this.taskId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;

				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},
		
		onClose:function(){
			this.$emit('changeRecord', '')
			this.modalObject.hide();
		},

		onDelete:function(){
			
			if(this.data.id){

				this.isSending=true
				deleteTask({data:this.data}).then(response => {
					if(!response.statusText){
						this.isSending=false
						if(response.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasDeleted'));
							this.$emit('changeRecord', '')
							this.data = [];
							this.modalObject.hide();
						}else if(response.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeDeleted'));
						}else if(response.resCode==2){
							this.toast.warning(this.$t('msgCore.dataWasNotDeleted'));
						}else if(response.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					}else{
						this.isSending=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
				
			}
			
		},
	
	},
	
	watch: {
		taskId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
	
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg">
			<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.DELETE_RECORD') }} <b><span>{{ data.title }} </span></b></h6>
					
				</div>
		
						<div v-if="metaData.modulAccess && (auth.tasksDelete)" class="modal-body">
						
							<div class="form-row">
							
								<div class="form-group col-md-2 col-12">
																																			
									<label><b>{{ $t('msgCore.ID') }}</b></label><br>
									{{data.id}}
								</div>
								
								<div class="form-group col-md-10 col-12">
																																			
									<label><b>{{ $t('msgCore.Title') }}</b></label><br>
									{{ data.title }}
								</div>
								
							</div>	
									
								
						</div>
						
						<div v-else class="modal-body">
							<div class="row">
								<div class="col-12 mt-3">
									<Alert type="warning" :label="$t('msgCore.accessDenied')" />
								</div>
							</div>
						</div>
								
						
						<div class="modal-footer">
						
							<div class="btn-group">
								<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>

								
								<LoadingButton :isDisabled="(!auth.tasksDelete || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onDelete" :label="'msgCore.btnDelete'" color="danger"></LoadingButton>
							</div>	
							
						</div>
					
			</div>

		</div>
		
	</div>
	</div>
		
</template>


